import { renderToString } from 'react-dom/server';
import { getServerState } from 'react-instantsearch';

import { DynamicComponents, ListOfFlats } from '@/templates';

import { getPage } from '@/graphql/queries/getPage';
import { dynamicComponentsTransformer } from '@/graphql/transformers';
import { routes } from '@/lib';
import { listingChromeFor } from '@/utils';

import type { TypeTheme } from '@/types';
import type { ListingChromeProps } from '@/utils';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import type { InstantSearchServerState } from 'react-instantsearch';

type FlatCategoryProps = {
  page: {
    theme: TypeTheme;
    langcode: {
      id: 'es';
    };
    // TODO: tipar
    attributes: any;
    menu: any[];
    preFooter: any[];
  };
  serverState: InstantSearchServerState;
  chrome: ListingChromeProps;
  serverUrl: string;
};

const FlatCategory = ({
  serverState,
  serverUrl,
  chrome,
  page: {
    attributes: { Content: dynamicContent },
  },
}: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <>
    <ListOfFlats
      defaultArea="todas las zonas"
      typeText="de alquiler"
      serverState={serverState}
      serverUrl={serverUrl}
      type="ALQUILER"
      {...chrome}
    />

    {dynamicContent.map(({ __typename, ...props }: any, index: number) => (
      <DynamicComponents
        type={__typename}
        {...props}
        key={`${__typename}-${index}`}
      />
    ))}
  </>
);

export const getServerSideProps: GetServerSideProps<
  FlatCategoryProps
> = async ({ req, resolvedUrl }) => {
  const proto = ((req.headers['x-forwarded-proto'] as string) || 'http').split(
    ',',
  )[0];
  const serverUrl = `${proto}://${req.headers.host}${resolvedUrl}`;

  const {
    pages,
    menus,
    preFooter,
    hasCustomFooter,
    footerStyle,
    stickyMenu,
    listingChrome,
  } = await getPage(routes.flats.rent.index);
  const chrome = listingChromeFor(listingChrome, 'ALQUILER');
  const attributes = pages?.[0] || {};
  attributes.Content = attributes?.Content
    ? dynamicComponentsTransformer(attributes.Content)
    : [];

  const serverState = await getServerState(
    <ListOfFlats
      defaultArea="todas las zonas"
      typeText="de alquiler"
      serverUrl={serverUrl}
      type="ALQUILER"
      {...chrome}
    />,
    {
      renderToString,
    },
  );

  return {
    props: {
      page: {
        theme: 'light' as TypeTheme,
        langcode: {
          id: 'es',
        },
        attributes,
        menu: menus || [],
        preFooter: preFooter || null,
        hasCustomFooter,
        footerStyle,
        stickyMenu,
      },
      serverState: JSON.parse(JSON.stringify(serverState)),
      chrome,
      serverUrl,
    },
  };
};

export default FlatCategory;
